(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1042],{

/***/ 7995:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/yardim-merkezi/[userTypeSlug]",
      function () {
        return __webpack_require__(95621);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85157);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93288);
/* harmony import */ var components_HelpCenter_HelpCenterCategoryAndArticlesListWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55485);
/* harmony import */ var components_Seo_SeoWrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15010);
/* harmony import */ var hooks_useBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54865);
/* harmony import */ var services_LocalizationService__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55389);






var HelpCenterArticlesByUserType = function(param) {
    var helpCenterUserType = param.helpCenterUserType, slugTranslations = param.slugTranslations, helmetSettings = param.helmetSettings;
    var onlyTekneViaBreadcrumb = (0,hooks_useBreadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* .useBreadcrumbs */ .h)().onlyTekneViaBreadcrumb;
    services_LocalizationService__WEBPACK_IMPORTED_MODULE_4__/* .localizationService.slugTranslations */ .R.slugTranslations = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, slugTranslations);
    var breadcrumbs = [
        onlyTekneViaBreadcrumb,
        {
            label: "helpCenter:general.title",
            link: "/yardim-merkezi",
            isTranslatable: true
        },
        {
            label: helpCenterUserType.title,
            link: "/yardim-merkezi/".concat(helpCenterUserType.slug),
            isTranslatable: false
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Seo_SeoWrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        helmetSettings: helmetSettings,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_HelpCenter_HelpCenterCategoryAndArticlesListWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            helpCenterCategories: helpCenterUserType.help_center_categories,
            breadcrumbItems: breadcrumbs,
            title: helpCenterUserType.title,
            description: helpCenterUserType.description,
            isVisibleArticleTitle: true
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (HelpCenterArticlesByUserType);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3457,5362,7154,9774,2888,179], function() { return __webpack_exec__(7995); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);